import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

export const ConfirmRegistrationSuccess = ({
  callbackFunction,
  params,
  title,
  text,
}) => {
  MySwal.fire({
    title: title,
    text: text,
    icon: "success",
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
      popup: "format-pre",
    },
    buttonsStyling: true,
  }).then(function (result) {
    if (result.value && callbackFunction) {
      callbackFunction(params);
    }
  });
};

export const ConfirmRegistrationError = ({
  callbackFunction,
  params,
  title,
  text,
}) => {
  MySwal.fire({
    title: title,
    text: text,
    icon: "error",
    confirmButtonText: "ตกลง",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  }).then(function (result) {
    if (result.value && callbackFunction) {
      callbackFunction(params);
    }
  });
};

export const ConfirmAction = ({ callbackFunction, params, title, text }) => {
  MySwal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then(function (result) {
    if (result.value && callbackFunction) {
      callbackFunction(params);
    }
  });
};
